import { gitContract } from '@terra/shared-contracts-git';
import { createTerraOrpcClient } from '@terra/shared-utils';

const SERVICE_NAME = 'git';

export const gitClient = createTerraOrpcClient({
  contract: gitContract,
  serviceName: SERVICE_NAME,
});
